import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import Spinner from "../../Layouts/Spinner";
import {
  addServiceValidation,
} from "../../Constant/constant";
import {
  getSingleCategoryId,
} from "../../../redux/categories/action";
import ReactSelect from "react-select";
import { userCategoriesList } from "../../../redux/user/action";
import {
  getSingleIdService,
  updateOneService,
} from "../../../redux/service/action";

const UpdateService = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const singleService = useSelector(
    (state) => state?.reusableSlice?.getSingleServiceId
  );


  const categoryList = useSelector(
    (state) => state?.reusableSlice?.categoryList
  );
  const [params, setParams] = useState({
    type: 2,
  });

  useEffect(() => {
    dispatch(userCategoriesList(params));
  }, [dispatch, params]);
  console.log(singleService, "sdfsfdsf");

  useEffect(() => {
    if (id) {
      dispatch(getSingleIdService(id));
    }
  }, [id]);

  useEffect(() => {
    if (id) {
      dispatch(getSingleCategoryId(id));
    }
  }, [id]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      title: singleService?.title || "",
      status: singleService?.status || "",
      position: singleService?.position || "",
      ar_title: singleService?.ar_title || "",
      category_id: singleService?.category_id || "",
    },
    validationSchema: addServiceValidation,
    onSubmit: (values) => {
      handleSubmit(values);
    },
  });

  const handleSubmit = async (values) => {
    const data = {
      ...values,
      id: singleService?.id,
    };
    dispatch(updateOneService(data, setLoading, navigate));
  };

  const handleChangeStatus = (e) => {
    const gender = e.target.value;
    formik.setFieldValue("status", Number(gender));
  };
  const handleChangePosition = (e) => {
    const pos = e.target.value;
    formik.setFieldValue("position", Number(pos));
  };

  console.log(formik.errors, "sadfsfdsfsfdsfsd");
  return (
    <div className="p-3">

    <div className=" category-wrapper">
      <h3 className="pb-3">Update Service</h3>
      <form onSubmit={formik.handleSubmit}>
        <div className="row ">
          <div className="col-md-4 form-group">
            <label>Category</label>
            <ReactSelect
              isMulti
              getOptionLabel={(option) => option.title}
              getOptionValue={(option) => option.id}
              options={categoryList?.categories}
              placeholder="Select Categories"
              onChange={(values) => {
                const selectedSubCategories = values
                  .map((option) => option.id)
                  .join(",");
                formik.setFieldValue("category_id", selectedSubCategories);
              }}
              value={
                Array.isArray(categoryList?.categories) &&
                categoryList?.categories?.filter((cat) => {
                  const selectedIds = formik?.values?.category_id
                    ?.split(",")
                    .map((id) => parseInt(id, 10));
                  return selectedIds?.includes(cat.id);
                })
              }
            />
            {formik.touched.category_id && formik.errors.category_id ? (
              <div className="error">{formik.errors.category_id}</div>
            ) : null}
          </div>
          <div className="col-md-4 form-group">
            <label>Title</label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter category title"
              name="title"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.title}
            />
            {formik.touched.title && formik.errors.title ? (
              <div className="error">{formik.errors.title}</div>
            ) : null}
          </div>

          <div className="col-md-4 form-group">
            <label>Ar Title</label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter ar title"
              name="ar_title"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.ar_title}
            />
            {formik.touched.ar_title && formik.errors.ar_title ? (
              <div className="error">{formik.errors.ar_title}</div>
            ) : null}
          </div>

          <div className="form-group col-md-4">
            <label htmlFor="status">Position</label>
            <select
              id="position"
              title="position"
              className="form-control"
              onChange={handleChangePosition}
              onBlur={formik.handleBlur}
              value={formik.values.position}
            >
              <option value="">Select Position</option>
              {Array.from({ length: 50 }, (_, i) => i + 1).map(
                        (num) => (
                          <option key={num} value={num}>
                            {num}
                          </option>
                        )
                      )}
            </select>
            {formik.touched.position && formik.errors.position ? (
              <div className="error">{formik.errors.position}</div>
            ) : null}
          </div>

          <div className="form-group col-md-4">
            <label htmlFor="status">Status</label>
            <select
              id="status"
              title="status"
              className="form-control"
              onChange={handleChangeStatus}
              onBlur={formik.handleBlur}
              value={formik.values.status}
            >
              <option value="">Select Status</option>
              <option value="1">Active</option>
              <option value="2">Inactive</option>
            </select>
            {formik.touched.status && formik.errors.status ? (
              <div className="error">{formik.errors.status}</div>
            ) : null}
          </div>
        </div>
        <div
          className="d-flex align-items-center justify-content-center mt-3  "
          style={{ columnGap: "20px" }}
        >
          <button
            className="submit-btn  "
            onClick={() => {
              navigate("/services");
            }}
            style={{ width: "max-content" }}
          >
            Back
          </button>
          <button
            className="submit-btn   "
            style={{ width: "max-content" }}
            type="submit"
          >
            {!loading ? "Submit" : <Spinner />}
          </button>
        </div>
      </form>
    </div>
    </div>
  );
};

export default UpdateService;
